var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-tooltip',{attrs:{"label":"Verified user 👌","type":"is-dark","delay":300,"animated":false,"position":"is-right"}},[_c('span',{staticClass:"icon badgeVerified",staticStyle:{"font-size":"0.7em"}},[_c('i',{staticClass:"fas fa-badge-check has-text-infoNOPE"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }